import { useContext } from 'react';
import { HttpClientContext } from '../api/HttpClientContext';
export const useHttpClient = () => useContext(HttpClientContext);